module.exports = __webpack_public_path__ + "static/img/4.19852f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/4.png
// module id = qhHO
// module chunks = 0